<template>
  <svg v-if="!isFilled"
       xmlns="http://www.w3.org/2000/svg"
       width="21"
       height="21"
       viewBox="0 0 21 21"
       class="fill-current"
  >
    <g transform="matrix(0.921643,0,0,0.923505,0.82275,0.75651)">
        <path
          d="M18.5,10L17,10L17,6C17,4.9 16.1,4 15,4L11,4L11,2.5C11,1.837 10.737,1.201 10.268,0.732C9.799,0.263 9.163,0 8.5,0C7.837,0 7.201,0.263 6.732,0.732C6.263,1.201 6,1.837 6,2.5L6,4L2,4C0.9,4 0.01,4.9 0.01,6L0.01,9.8L1.5,9.8C2.99,9.8 4.2,11.01 4.2,12.5C4.2,13.99 2.99,15.2 1.5,15.2L0,15.2L0,19C0,20.1 0.9,21 2,21L5.8,21L5.8,19.5C5.8,18.01 7.01,16.8 8.5,16.8C9.99,16.8 11.2,18.01 11.2,19.5L11.2,21L15,21C16.1,21 17,20.1 17,19L17,15L18.5,15C19.163,15 19.799,14.737 20.268,14.268C20.737,13.799 21,13.163 21,12.5C21,11.837 20.737,11.201 20.268,10.732C19.799,10.263 19.163,10 18.5,10Z"
          style="fill:none;fill-rule:nonzero;stroke:currentColor;stroke-width:1.64px;"
        />
    </g>
  </svg>

  <svg v-else width="21" height="21" viewBox="0 0 21 21" class="fill-current" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.5 10H17V6C17 4.9 16.1 4 15 4H11V2.5C11 1.83696 10.7366 1.20107 10.2678 0.732233C9.79893 0.263392 9.16304 0 8.5 0C7.83696 0 7.20107 0.263392 6.73223 0.732233C6.26339 1.20107 6 1.83696 6 2.5V4H2C0.9 4 0.00999999 4.9 0.00999999 6V9.8H1.5C2.99 9.8 4.2 11.01 4.2 12.5C4.2 13.99 2.99 15.2 1.5 15.2H0V19C0 20.1 0.9 21 2 21H5.8V19.5C5.8 18.01 7.01 16.8 8.5 16.8C9.99 16.8 11.2 18.01 11.2 19.5V21H15C16.1 21 17 20.1 17 19V15H18.5C19.163 15 19.7989 14.7366 20.2678 14.2678C20.7366 13.7989 21 13.163 21 12.5C21 11.837 20.7366 11.2011 20.2678 10.7322C19.7989 10.2634 19.163 10 18.5 10Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isFilled: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
